export default __webpack_public_path__ + "static/media/menu_outages_selected.1add8713.svg";